<template>
    <DashboardContainer>
        <AllAppointments/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import AllAppointments from '../components/appointments/AllAppointments'

export default {
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        AllAppointments
    }
}
</script>